import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Photo } from '@classifieds-sell/trademe-core-ui';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-summary-page-photos-media-section',
    templateUrl: './summary-page-photos-media-section.component.html',
    styleUrls: ['./summary-page-photos-media-section.component.scss']
})
export class SummaryPagePhotosMediaSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    private _destroyed$: Subject<void> = new Subject<void>();

    photos: Photo[] = [];
    youTubeVideoUrl: string;
    threeDTourUrl: string;

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.photos = this.draftData?.propertyPhotos?.photos || [];
            this.youTubeVideoUrl =
                this.draftData?.propertyPhotos?.youTubeVideoUrl;
            this.threeDTourUrl = this.draftData?.propertyPhotos?.threeDTourUrl;
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
